import { useCallback, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Text from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Switch } from "../../components/Switch";
import { queryBuilderStyles as sx } from "./QueryBuilder.styles";
import Chip from "@mui/material/Chip";
import HeaderSection from "../Search/HeaderSection";
import QueryBuilder from "./QueryBuilder";
import useQBFormField, { QBFormValues } from "../../hooks/useQBFormField";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  GetCustomerByIDDatatype,
  GetCustomerByIDSubject,
} from "../../types/GetCustomerByID.types";
import { temporaryQueryConstructor } from "./TemporaryQueryConstructor";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useGetMySearchPreference } from "../../api/Preferences/Subjects.api";
import {
  clearDataTypeFilters,
  clearSearchTerm,
  updateAdvSearchQuery,
  updateAll,
  updateAllFacets,
  updateAuthorFacets,
  updateAuthorFiltersLoader,
  updateDataType,
  updateFullText,
  updateLinkToDisplay,
  updateMarkedArticleCount,
  updateNewSearchStatus,
  updateOtherFiltersLoader,
  updatePage,
  updateRow,
  updateSearchResults,
  updateSearchTerm,
  updateSearchType,
  updateSubjectFacets,
  updateSubjectFilterLoader,
  updateSubjectName,
  updateSubjectType,
} from "../../store/slice/searchSlice";
import { queryConstructor } from "../../api/formQuery";
import { updateQuery } from "../../store/slice/queryForCountSlice";
import {
  isPreferenceAdded,
  removeOperatorFromEnd,
  showIsProfileToast,
  sortTags,
} from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { setModal } from "../../store/slice/modalSlice";
import {
  authorJsonFacetQuery,
  basicSearchForCounts,
  basicSearchMain,
  basicSearchQuery,
  jsonFacetQuery,
  subjectJsonFacetQuery,
} from "../../api/Search/BasicSearch.api";
import {
  clearAllFilters,
  clearAllFiltersValue,
  clearPublicationFilter,
  updataLibraryOpac,
  updateAllFilter,
  updateCollectionValue,
  updateConsortiaCollection,
  updateDSPACECollection,
  updateIsOpac_dspace,
  updateJgateCollection,
  updateMyLibraryCollection,
  updateOnosCollection,
  updatePersonalLibrary,
  updateSort,
} from "../../store/slice/filterSlice";
import { usagelogApi } from "../../api/usageReportApi";
import { notify } from "../../utils/Notify";
import JournalPopUp from "./JournalPopUp";
import { getListOfJournal } from "../../api/browseJournal";
import objectToQueryString from "../browseJournal/objToQuery";
import { GetMyPreferenceData } from "../../types/GetMySubjects.types";
import { dataTypes } from "../../utils/constants";
import { getBulkLinkRecords } from "../../api/linkResolverApi";
import { clearAllSetSearch } from "../../store/slice/setSearch";
import { updateIsAuthorResult } from "../../store/slice/authorFinderSlice";
import { updateBrowseJournalSearch } from "../../store/slice/browseJournal";
import FormAdvanceQueryTerm from "./FormAdvanceQueryTerm";
import { constants } from "buffer";
import {
  Checkbox,
  Link,
  Select,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { CustomTooltip } from "../MyLibrary/MyAlerts/Alerts.style";
import { IconButton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { clearAllFilters as clearAllJournalFilters } from "../../store/slice/browseFilterSlice";
import { getValidCharacters } from "../../utils/validateSearchTerm";
// import { FormProvider, useForm } from "react-hook-form";

export type QBField = { id: number };

const AdvancedSearch = () => {
  const {
    fields,
    control,
    append,
    remove,
    handleSubmit,
    watch,
    setValue,
    getValues,
  } = useQBFormField();
  // const { fields, control, append, remove, handleSubmit, watch, setValue,setError} =
  //   useQBFormField();
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.login);
  const navigate = useNavigate();
  let userId = sessionStorage.getItem("user_id");
  let session_key = sessionStorage.getItem("session_key");

  const isPreferenceEnabled = sessionStorage.getItem("preference") === "true";
  const [onJournal, setJournal] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState<number[]>([0]);
  const [isPreference, setIsPreference] = useState(isPreferenceEnabled);
  const [loading, setLoading] = useState(false);
  const [selectedTags, setSelectedTags] = useState<number[]>([]);
  const [subjectData, setSubjectData] = useState<GetCustomerByIDSubject[]>([]);
  const [displayQuery, setDisplayQuery] = useState<string>("");
  const [allTags, setAllTags] = useState<GetCustomerByIDDatatype[]>([]);
  const [journalData, setJournalData] = useState<any[]>([]);
  const [onChange, setOnChange] = useState<any>(fields);
  const [indexOf, setIndexOf] = useState<any>();
  const [selectedJournal, setSelectedJournal] = useState<string[]>([]);
  const [autoSearchKeyword, setAutoSearchKeyword] = useState<any>("");
  const [autoSearch, setAutoSearch] = useState<any>([]);
  const [pageIndex, setpageIndex] = useState<any>();
  const [checkDoi, setCheckDoi] = useState(false);
  const [extraStringQuery, setExtraStringQuery] = useState("");
  const [dropdown, setDropDown] = useState(false);
  //Get Customer Data
  const customerData = useAppSelector(
    (state) => state.customer.customerDetails,
  );

  //Get Personalized Data for Preference
  const { data: myPreference, refetch } = useGetMySearchPreference(
    selector.user_id,
    isPreference,
  );
  const searchReducer = useAppSelector((state) => state.searchReducer);

  const profileData = useAppSelector((state: any) => state.login);

  const isNavigatingBack = useAppSelector(
    (state) => state.searchReducer.isNavigatingBack,
  );
  // const methods = useForm();

  const [selectedLetterTagsPublisher, setSelectedLetterTagsPublisher] =
    useState(Array(28).fill(false));
  const [selectedTagPublisher, setSelectedTagPublisher] = useState<String>("");

  // Media queries for breakpoints
  const is_xs = useMediaQuery("(max-width: 299px)");
  const isxs = useMediaQuery("(min-width: 299px) and (max-width: 600px)");
  const isSm = useMediaQuery("(min-width: 600px) and (max-width: 899px)");
  const isMd = useMediaQuery("(min-width: 900px) and (max-width: 1199px)");
  const islg = useMediaQuery("(min-width: 1200px) and (max-width: 1535px)");
  const isXl = useMediaQuery("(min-width: 1536px)");

  const updateSelectedTagsPublisher = (element: any, index: any) => {
    const tagPublisherMapping: any = {
      2: "(A OR B OR C)",
      3: "(D OR E OR F)",
      4: "(G OR H OR I)",
      5: "(J OR K OR L)",
      6: "(M OR N OR O)",
      7: "(P OR Q OR R)",
      8: "(S OR T OR U)",
      9: "(V OR X OR Y OR Z)",
    };
    let temp = Array(28).fill(false);
    if (selectedTagPublisher[element] && element == 0) {
      setSelectedLetterTagsPublisher(temp);
      setSelectedTagPublisher("");
    } else {
      if (element == 0) {
        temp[0] = true;
        setSelectedLetterTagsPublisher(temp);
        setSelectedTagPublisher("");
      } else if (element == 1) {
        temp[1] = true;
        setSelectedLetterTagsPublisher(temp);
        setSelectedTagPublisher("1");
      } else {
        temp[element] = true;
        setSelectedLetterTagsPublisher(temp);
        if (tagPublisherMapping.hasOwnProperty(element)) {
          setSelectedTagPublisher(tagPublisherMapping[element]);
        }
        // setSelectedTagPublisher(String.fromCharCode(element + 63));
      }
    }
  };
  const handleCloseJournalData = () => {
    const ofFields = [...fields];
    if (
      ofFields &&
      Array.isArray(ofFields) &&
      indexOf >= 0 &&
      indexOf < ofFields.length
    ) {
      // @ts-ignore
      ofFields[indexOf].journalSelected = [];
      // @ts-ignore
      ofFields[indexOf].selectedJournal = [];
    }
    setJournal(!onJournal);
  };

  const profileData1 = useAppSelector(
    (state: any) => state.customer.customerDetails,
  );
  const customerDataTypes: any = profileData1?.datatypes?.map((item: any) => {
    return item?.dat_resourcetype_id;
  });
  const onlyJournals =
    customerDataTypes?.length === 4 &&
    customerDataTypes.includes(1 && 2 && 5 && 24);

  const logBasicSearchUsageData = (usageActionID: any) => {
    const userId = sessionStorage.getItem("user_id");
    const informaticscustomer_Id = sessionStorage.getItem(
      "informaticscustomer_id",
    );
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;

    const userMasterId = profileData.user_id
      ? profileData.user_id
      : userId
        ? userId
        : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : informaticscustomer_Id
        ? informaticscustomer_Id
        : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      null,
      null,
      null,
      null,
      null,
      null,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      0,
    );
  };

  const profileStatus = sessionStorage.getItem("isProfileUser");

  useEffect(() => {
    const debounce = setTimeout(() => {
      refetch();
    }, 100);

    return () => {
      clearTimeout(debounce);
    };
  }, []);

  useEffect(() => {
    //refetch();

    dispatch(clearAllFilters());
    dispatch(clearDataTypeFilters());
    dispatch(updateMarkedArticleCount([]));
    dispatch(clearAllFiltersValue());
    dispatch(clearSearchTerm());
    dispatch(clearAllSetSearch());
    dispatch(updateSearchType("2"));
    dispatch(updateIsAuthorResult(false));
    dispatch(updateBrowseJournalSearch(false));
    dispatch(clearAllJournalFilters());

    dispatch(updateDSPACECollection(false));
    dispatch(updataLibraryOpac(false));
    dispatch(updateIsOpac_dspace(false));
  }, [dispatch, refetch]);

  const showLoginModal = useCallback(() => {
    if (!customerData?.allow_profile) return;
    if (sessionStorage.getItem("isLoginModalShowed") === "true") return;
    // if (profileStatus === "false" || customerData?.customer_id === 0) {
    if (customerData?.customer_id === 0) {
      dispatch(
        setModal({
          modalType: "SHOW_LOGIN",
          modalProps: {
            open: true,
            isProfileUser: profileStatus,
          },
        }),
      );
    }
    sessionStorage.setItem("isLoginModalShowed", "true");
  }, [customerData?.customer_id, dispatch, profileStatus]);

  useEffect(() => {
    showLoginModal();
  }, [profileStatus, showLoginModal, customerData?.customer_id]);

  const [activeScreenWidth, setActiveScreenWidth] = useState<number>(2);

  useEffect(() => {
    if (is_xs) {
      setActiveScreenWidth(0);
    } else if (isxs) {
      setActiveScreenWidth(1);
    } else if (isSm) {
      setActiveScreenWidth(2);
    } else if (isMd) {
      setActiveScreenWidth(3);
    } else {
      setActiveScreenWidth(5);
    }
  }, [is_xs, isxs, isSm, isMd]);

  //Set Initial Data
  useEffect(() => {
    try {
      if (customerData) {
        let filteredSubjectData: GetCustomerByIDSubject[] = [];
        let filteredSubjectIds: number[] = [];
        let filteredSubjectNames: string[] = [];
        let filteredAllTags: GetCustomerByIDDatatype[] = [];
        let filteredSelectedTags: number[] = [];
        let isAllSelected: boolean = true;
        const selectedDocTypes =
          Array.isArray(searchReducer.dataType) &&
          searchReducer.dataType?.filter((x) => x !== 2);
        const selectedSubjects =
          Array.isArray(searchReducer.subjectType) && searchReducer.subjectType;

        //Clear All Tag's Filters
        dispatch(clearDataTypeFilters());

        if (isPreference && myPreference) {
          //Get My Subject Data
          filteredSubjectData = myPreference.Subjects?.map(
            ({ subject2_details }) =>
              subject2_details.filter(({ is_favorite }) => is_favorite),
          )
            .flat()
            ?.map((l2) => {
              return {
                datsubjectmasterlevel1_id: -1, //Just for Integrity's Sake
                datsubjectmasterlevel2_id: l2.subject_id2,
                level2subject_name: l2.subject_name2,
              };
            });

          //Get My Subject Data IDs
          filteredSubjectIds = filteredSubjectData?.map(
            ({ datsubjectmasterlevel2_id }) => datsubjectmasterlevel2_id,
          );
          //Get My Subject Data Names
          filteredSubjectNames = filteredSubjectData?.map(
            ({ level2subject_name }) => level2subject_name,
          );

          //Get My Sources
          filteredAllTags = myPreference?.DataTypes?.map((source) => {
            return {
              dat_resourcetype_id: source.datatype_id,
              accesstype: source.datatype_name,
              image_small: source.datatype_name.toLocaleLowerCase(),
            };
          });

          //Get My Source ID's
          filteredSelectedTags = myPreference?.DataTypes.filter(
            ({ is_favorite }) => is_favorite,
          )?.map(({ datatype_id }) => datatype_id);

          filteredAllTags = customerData?.datatypes?.filter(
            (x) => x.dat_resourcetype_id !== 2,
          );
          filteredAllTags = filteredAllTags?.filter(
            (x) => x.dat_resourcetype_id !== 24,
          );
          filteredAllTags = filteredAllTags.filter(
            (x) => x.dat_resourcetype_id !== 5,
          );

          //Should Select All Tags if True
          isAllSelected =
            filteredSelectedTags.length === myPreference?.DataTypes.length;
        } else {
          //Get All Subject Data

          filteredSubjectData = customerData.subject;

          //Get All Subject Data IDs
          filteredSubjectIds = customerData.subject?.map(
            ({ datsubjectmasterlevel2_id }) => datsubjectmasterlevel2_id,
          );

          //Get My Subject Data Names
          filteredSubjectNames = customerData.subject?.map(
            ({ level2subject_name }) => level2subject_name,
          );

          //Get All Sources
          filteredAllTags = customerData?.datatypes?.filter(
            (x) => x.dat_resourcetype_id !== 2,
          );
          filteredAllTags = filteredAllTags?.filter(
            (x) => x.dat_resourcetype_id !== 24,
          );
          filteredAllTags = filteredAllTags.filter(
            (x) => x.dat_resourcetype_id !== 5,
          );
        }

        //Update Subjects
        setSubjectData(() => filteredSubjectData);

        //Update Subject Ids
        dispatch(updateSubjectType(filteredSubjectIds));
        setSelectedSubjects(() => filteredSubjectIds);

        //Update Subject Names
        dispatch(updateSubjectName(filteredSubjectNames));
        // setSelectedSubjectNames(() => filteredSubjectNames);

        let docArray: any = [];

        if (filteredAllTags) {
          docArray = [...filteredAllTags];
          if (!onlyJournals) {
            docArray.unshift({
              dat_resourcetype_id: 0, // Custom ID, 0 => All
              accesstype: "All",
              image_small: "all",
            });
          }
        }

        let selectedDoc = isAllSelected
          ? docArray?.map((x: any) => x?.dat_resourcetype_id)
          : filteredSelectedTags;

        /**
         * updating doc types
         */
        if (selectedTags.length && !isPreference) {
          setSelectedTags(selectedTags);
        } else if (
          selectedDocTypes &&
          selectedDocTypes.length &&
          !isPreference
        ) {
          setSelectedTags(selectedDocTypes);
          if (
            window.location.pathname === "/search-builder" &&
            !isNavigatingBack
          ) {
            setSelectedTags(selectedDoc);
          }
        } else {
          setSelectedTags(selectedDoc);
        }

        /**
         * updating subject types
         */
        if (selectedSubjects && selectedSubjects.length && !isPreference) {
          setSelectedSubjects(() => selectedSubjects);
          // updating subnames
          let subNames: string[] = [];
          for (let id of selectedSubjects) {
            for (let obj of customerData?.subject) {
              if (id === obj?.datsubjectmasterlevel2_id) {
                subNames.push(obj?.level2subject_name);
              }
            }
          }
          dispatch(updateSubjectName(subNames));
          // setSelectedSubjectNames(() => subNames);
        } else {
          setSelectedSubjects(() => filteredSubjectIds);
          //Update Subject Names
          dispatch(updateSubjectName(filteredSubjectNames));
          // setSelectedSubjectNames(() => filteredSubjectNames);
        }

        //Update Tags
        setAllTags(() => docArray);
        // setSelectedTags(selectedDoc);
        // dispatch(updateDataType(selectedDoc));
      }
    } catch (err) {
      console.log("Unknown error occoured");
    }
  }, [customerData, dispatch, isPreference, myPreference]);
  const setStandardTerm = (term: string) => {
    switch (term) {
      case "Title/Abstract/Keyword":
        return "TI/KW/Abst : ";
      case "Title":
        return "TI : ";
      case "Keyword only":
        return "KW : ";
      case "Title/Keyword":
        return "TIKW : ";
      case "Publication Year":
        return "Date : ";
      case "Author":
        return "AU : ";
      case "Author Affiliation":
        return "AF : ";
      case "ISSN":
        return "ISSN : ";
      case "ISBN":
        return "ISBN : ";
      case "DOI":
        return "DOI : ";
      case "Journal":
        return "JRNL : ";
      case "MeSH Keyword":
        return "MeSH : ";
      case "Publication Country":
        return "PC : ";
      case "IPC Classification No":
        return "IPC Classif. No : ";
      case "CPC Classification No":
        return "CPC Classif. No : ";
      case "Application No":
        return "Appl. No : ";
      case "Substances":
        return "Substances : ";
      case "Author Country":
        return "AC : ";
      case "Case Study Number":
        return "Case Study Number : ";
    }
  };

  const setStandardTermForUi = (term: string) => {
    switch (term) {
      case "Title/Abstract/Keyword":
        return "TI/KW/Abst";
      case "Title":
        return "TI";
      case "Keyword only":
        return "KW";
      case "Title/Keyword":
        return "TIKW";
      case "Publication Year":
        return "Date";
      case "Author":
        return "AU";
      case "Author Affiliation":
        return "AF";
      case "ISSN":
        return "ISSN";
      case "ISBN":
        return "ISBN";
      case "DOI":
        return "DOI";
      case "Journal":
        return "JRNL";
      case "MeSH Keyword":
        return "MeSH : ";
      case "Publication Country":
        return "PC : ";
      case "IPC Classification No":
        return "IPC Classif. No : ";
      case "CPC Classification No":
        return "CPC Classif. No : ";
      case "Application No":
        return "Appl. No : ";
      case "Substances":
        return "Substances : ";
      case "Author Country":
        return "AC : ";
      case "Case Study Number":
        return "Case Study Number : ";
    }
  };

  // To Update Query Editor TextField
  useEffect(() => {
    watch("myFields");
    const subscription = watch(({ myFields }: any) => {
      if (myFields) {
        const condtions = myFields?.map((x: any) => x.conditionField);
        const searchTerms = myFields?.map((x: any) => `#${x.qbIndex + 1}`);
        const criteria = myFields?.map((x: any) => x.criteriaField);
        const term = myFields?.map((x: any, i: number) => {
          if (criteria[i] == "Author") {
            return `${
              x.author_lastname && x.author_firstname_fz
                ? x.author_lastname + "," + x.author_firstname_fz
                : x.author_lastname
                  ? x.author_lastname
                  : x.author_firstname_fz
                    ? x.author_firstname_fz
                    : ""
            } `;
          } else if (criteria[i] == "Publication Year") {
            return `${x.from !== undefined ? `${x.from}` : ""}${
              x.to !== undefined ? ` - ${x.to}` : ""
            }`;
          } else {
            return x.searchTerm;
          }
        });

        const formQueryX = (a: any[], b: any[], c: any[], d: any[]) => {
          let arr: string[] = [];
          if (a.length && b.length) {
            for (let i = 0; i < a.length; i++) {
              if (d[i]) {
                if (
                  c[i] === "Title/Abstract/Keyword" ||
                  c[i] === "Title" ||
                  c[i] === "Keyword only" ||
                  c[i] === "Title/Keyword"
                ) {
                  let term = d[i];
                  if (d[i].split(/\s+/).length > 1) {
                    let q = d[i].replace(/^\(|\)$/g, "");
                    term = q?.trim() ? `[${q?.trim()}]` : "";
                  }
                  let criteria = setStandardTermForUi(c[i])?.replace(":", "");
                  arr = [...arr, term, criteria, b[i]];
                } else {
                  let criteria = setStandardTermForUi(c[i])?.replace(":", "");
                  arr = [...arr, d[i]?.trim(), criteria, b[i]];
                }
              }
            }
          }
          return arr;
        };

        const formQuery = (a: any[], b: any[], c: any[], d: any[]) => {
          let arr: string[] = [];
          if (a.length && b.length) {
            for (let i = 0; i < a.length; i++) {
              if (d[i]) {
                if (
                  c[i] === "Title/Abstract/Keyword" ||
                  c[i] === "Title" ||
                  c[i] === "Keyword only" ||
                  c[i] === "Title/Keyword"
                ) {
                  let term = d[i];
                  if (d[i].split(/\s+/).length > 1) {
                    let q = d[i].replace(/^\(|\)$/g, "");
                    term = `(${q})`;
                  }
                  arr = [...arr, setStandardTerm(c[i]), term, b[i]];
                } else {
                  arr = [...arr, setStandardTerm(c[i]), d[i], b[i]];
                }
              }
            }
          }
          return arr;
        };

        let x = formQuery(searchTerms, condtions, criteria, term);
        x.pop();
        setDisplayQuery(() => x.join("  "));
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  //Handle Tags
  const handleTags = (id: number) => {
    if (onlyJournals) {
      return;
    }
    // usageReport("13");
    logBasicSearchUsageData(13);
    sessionStorage.setItem("preference", "false");
    setIsPreference(false);
    let allDocIds: any = customerData?.datatypes
      .filter((x) => x.dat_resourcetype_id !== 2)
      ?.map((obj) => obj?.dat_resourcetype_id);
    if (id === 0) {
      // if the preference is on and user select all the preference toggle should be turn off
      sessionStorage.setItem("preference", "false");
      setIsPreference(false);
      //"All" toggle
      if (selectedTags.length === allDocIds?.length + 1) {
        setSelectedTags([]);
      } else {
        setSelectedTags(() => [...allDocIds, 0]);
      }
    } else {
      if (selectedTags.includes(0)) {
        // In ALL mode — switch to specific mode with only this type selected
        setSelectedTags([id]);
      } else if (selectedTags.includes(id)) {
        //Remove from specific mode
        const newArr = selectedTags
          .filter((item) => item !== id)
          .filter((x) => x !== 0);
        setSelectedTags(() => newArr);
      } else {
        //Add to specific mode
        let curr = [...selectedTags, id];
        setSelectedTags(curr);
      }
    }
  };

  //Main Search Function
  const handleFormSubmit = async ({ myFields: dasFields }: any) => {
    let myFields: any[] = dasFields;

    const hasInvalidSearchTerm = myFields?.some((item: any) => {
      const validCharacters = getValidCharacters(item.searchTerm.trim());
      return item.searchTerm.trim() !== "" && validCharacters.length < 3;
    });

    if (
      (myFields.length > 0 &&
        myFields.at(-1)?.criteriaField === "Title/Abstract/Keyword") ||
      myFields.at(-1)?.criteriaField === "Title" ||
      myFields.at(-1)?.criteriaField === "Title/Keyword" ||
      myFields.at(-1)?.criteriaField === "MeSH Keyword" ||
      myFields.at(-1)?.criteriaField === "Substances"
    ) {
      if (hasInvalidSearchTerm) {
        notify("error", "Search term must contain at least 3 characters.");
        return;
      }
    }

    if (
      myFields.length > 0 &&
      !myFields.at(-1)?.searchTerm &&
      myFields.at(-1)?.criteriaField !== "Publication Year" &&
      myFields.at(-1)?.criteriaField !== "Author"
    ) {
      myFields = myFields.slice(0, -1);
    }

    setLoading(true);
    let advancedSearchQuery = formAdvanceQuery(myFields);
    // Have to remove if the last word is any operator [AND, OR, NOT] not followed by any other word.
    advancedSearchQuery = removeOperatorFromEnd(advancedSearchQuery);

    const searchTerm = extraStringQuery
      ? formSearchTerm(myFields) + " " + extraStringQuery
      : formSearchTerm(myFields);
    if (searchTerm === "specialChar") {
      notify("error", "Please input valid keyword / topic to search");
      setLoading(false);
      return;
    }

    let tags = [...selectedTags];
    if (tags.includes(1) && !tags.includes(2)) tags.push(2);
    if (tags.includes(1) && !tags.includes(5)) tags.push(5);
    if (tags.includes(1) && !tags.includes(24)) tags.push(24);
    if (!tags.includes(1) && tags.includes(2))
      tags = tags.filter((tag) => tag !== 2);
    if (!tags.includes(1) && tags.includes(5))
      tags = tags.filter((tag) => tag !== 5);
    if (!tags.includes(1) && tags.includes(24))
      tags = tags.filter((tag) => tag !== 24);

    let encodedTags = "";
    const removeIds = [0, 100, 101];
    // if (selectedTags.length === 1 && selectedTags[0] === 0) {
    if (tags.includes(0)) {
      // encodedTags = "(1 OR 4 OR 2 OR 3 OR 8 OR 24)";;
      const filtered = tags.filter((item: any) => !removeIds.includes(item));
      encodedTags = `(${temporaryQueryConstructor(filtered)})`;
    } else {
      encodedTags = `(${temporaryQueryConstructor(tags)})`;
    }

    dispatch(updateDataType(tags));

    let encodedSubjects = "";
    if (selectedSubjects.length === 0) {
      encodedSubjects = `(${temporaryQueryConstructor(
        subjectData?.map((x) => x.datsubjectmasterlevel2_id),
      )})`;
    } else {
      encodedSubjects = `(${temporaryQueryConstructor(selectedSubjects)})`;
    }

    let queryObj: any = {
      page: 1,
      sort: "dateofpublication desc",
      fq__resource_type: encodedTags,
      rows: 15,
      customerid: selector.informaticscustomer_id,
      sessionid: sessionStorage.getItem("session_key"),
      op_mode: "and",
      profileuserid: userId,
      datsearchtype_id: "2",
    };

    if (encodedSubjects !== "()") {
      queryObj.fq__subjects_id_l2 = encodedSubjects;
    }
    // queryObj.datsearchtype_id = 2;

    const isOnlyConsortiaAccess = customerData?.product_type === "7";
    if (isOnlyConsortiaAccess) {
      queryObj.fq__acl_group = customerData?.consortia_filter;
    }
    // update advance search query to redux
    dispatch(updateAdvSearchQuery(advancedSearchQuery));

    let fullTextQuery = await queryConstructor({
      ...queryObj,
      // fq__fulltext: true,
      "fq__(fulltext": `true OR acl_group=(${profileData.informaticscustomer_id}))`,
    });

    let logAdvanceQuery = await queryConstructor({
      ...queryObj,
      logsearchhistory: true,
    }); //To log the search

    let allQuery = await queryConstructor({
      ...queryObj,
    });

    fullTextQuery = fullTextQuery + "&" + advancedSearchQuery;
    allQuery = allQuery + "&" + advancedSearchQuery;
    logAdvanceQuery = logAdvanceQuery + "&" + advancedSearchQuery; //To log the search

    // Update Query
    dispatch(
      updateQuery({
        fullTextQuery: fullTextQuery,
        allTextQuery: allQuery,
      }),
    );

    let searchedData: any;

    if (
      myFields.length > 0 &&
      // !myFields.at(-1)?.searchTerm &&
      myFields.at(-1)?.criteriaField === "IPC Classification No"
      // myFields.at(-1)?.criteriaField === "CPC Classification No"
    ) {
      searchedData = {
        key: "IPC Classic No- ",
        value: searchTerm.trim(),
      };
    } else if (
      myFields.length > 0 &&
      myFields.at(-1)?.criteriaField === "CPC Classification No"
    ) {
      searchedData = {
        key: "CPC Classic No- ",
        value: searchTerm.trim(),
      };
    } else {
      searchedData = {
        key: "search-term",
        value: searchTerm.trim(),
      };
    }

    // const searchedData = {
    //   key: "search-term",
    //   value: searchTerm.trim(),
    // };

    dispatch(
      updateAllFilter({
        key: "search-term",
        value: searchTerm,
      }),
    );

    // const fullTextData = await basicSearchMain(fullTextQuery);
    const fullTextData = await basicSearchQuery(fullTextQuery);

    // const allData = await basicSearchMain(allQuery);
    //await basicSearchMain(logAdvanceQuery);
    const allCount = await basicSearchForCounts(logAdvanceQuery);
    // await linkToDisplay(fullTextData?.docs);

    // to get count
    // const allText = await basicSearchForCounts(allQuery);
    // const fulltext = await basicSearchForCounts(fullTextQuery);

    // if (fulltext.hits === 0) {
    if (fullTextData.hits === 0) {
      // const allData = await basicSearchMain(allQuery);
      const allData = await basicSearchQuery(allQuery);
      dispatch(updateSearchResults(allData));
    } else {
      dispatch(updateSearchResults(fullTextData));
    }

    // Copied from SearchHistory
    dispatch(updateSort("dateofpublication desc"));
    dispatch(clearAllFiltersValue());
    dispatch(updateFullText(true));
    dispatch(updateAll(false));
    dispatch(clearAllFilters());
    dispatch(clearPublicationFilter());
    dispatch(updateAllFilter(searchedData));
    dispatch(updateNewSearchStatus(true));
    dispatch(updateRow(15));
    dispatch(updatePage(1));

    dispatch(updateFullText(true));
    dispatch(updateAll(false));
    setLoading(false);

    if (fullTextData?.docs) {
      navigate("/basicSearchScreen", {
        state: {
          searchTerm: searchTerm,
          fullTextQuery: fullTextQuery,
          allQuery: allQuery,
          // allCount: allText?.hits,
          // fullCount: fulltext?.hits,
          allCount: fullTextData.hits,
          fullCount: allCount.hits,
          from: "searchBuilder",
        },
      });
    }
    await linkToDisplay(fullTextData?.docs);

    //JsonFacets
    dispatch(updateSubjectFilterLoader(true));
    dispatch(updateAuthorFiltersLoader(true));
    dispatch(updateOtherFiltersLoader(true));
    const subjectFacetData = await subjectJsonFacetQuery(fullTextQuery);
    dispatch(updateSubjectFacets(subjectFacetData?.jsonfacets));
    dispatch(updateSubjectFilterLoader(false));
    const authorFacetData = await authorJsonFacetQuery(fullTextQuery);
    dispatch(updateAuthorFacets(authorFacetData?.jsonfacets));
    dispatch(updateAuthorFiltersLoader(false));
    const otherFacetData = await jsonFacetQuery(fullTextQuery);
    dispatch(updateAllFacets(otherFacetData?.jsonfacets));
    dispatch(updateOtherFiltersLoader(false));
    const criteriaFields = myFields.map((field) => field.criteriaField);
    const uniqueCriteria = new Set(criteriaFields);

    if (uniqueCriteria.size === 1 && uniqueCriteria.has("MeSH Keyword")) {
      logBasicSearchUsageData(137);
    }
    logBasicSearchUsageData(14);
  };

  const formAdvanceQuery = (myFields: any): string => {
    function addParentheses(input: string) {
      input = input.toLocaleLowerCase();
      if (
        input.includes(" or ") ||
        input.includes(" and ") ||
        input.includes(" not ")
      ) {
        // Split the input string by logical operators (AND, OR, NOT)
        const terms = input.split(/\b(and|or|not)\b/);

        // Remove empty strings from the array
        const filteredTerms = terms.filter(
          (term: string) => term.trim() !== "",
        );

        // Add parentheses around each non-operator single term
        const formattedTerms = filteredTerms.map((term: string) => {
          const trimmedTerm = term.trim();
          const isOperator = /\b(and|or|not)\b/.test(trimmedTerm);

          if (isOperator || !trimmedTerm.includes(" ")) {
            return isOperator ? ` ${term.trim()} ` : `${term.trim()}`; // Keep operators and the last term as-is
          } else {
            return `(${trimmedTerm})`; // Add parentheses around single terms
          }
        });

        // Join the terms back together with the original operators
        const output = formattedTerms.join("");

        return output;
      } else {
        return input;
      }
    }

    try {
      let queryString = "";
      for (let i = 0; i < myFields.length; i++) {
        let isLastField = i === myFields.length - 1;
        if (
          myFields[i].criteriaField === "Title/Abstract/Keyword" &&
          myFields[i].searchTerm !== ""
        ) {
          if (
            myFields[1]?.searchTerm === "" &&
            myFields.length === 2 &&
            myFields[1]?.criteriaField !== "Author" &&
            myFields[1]?.criteriaField !== "Publication Year"
          ) {
            queryString +=
              ("titleKeywordsAbs=" +
                myFields[i].searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm);
            break;
          }
          queryString +=
            `titleKeywordsAbs=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${
              (!isLastField && myFields[myFields.length - 1].searchTerm) ||
              (myFields[myFields.length - 1].from &&
                myFields[myFields.length - 1].to) ||
              myFields[myFields.length - 1].author_firstname_fz ||
              myFields[myFields.length - 1].author_lastname
                ? myFields[i].conditionField
                : ""
            }` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "Title") {
          queryString +=
            `title_fz=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "Title/Keyword") {
          queryString +=
            `(title_fz=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            } OR keywords_fz:${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            })` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "Publication Year") {
          queryString +=
            `yearfrom=[${myFields[i].from + " TO " + myFields[i].to}]` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "Keyword only") {
          queryString +=
            `keywords_fz=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "MeSH Keyword") {
          queryString +=
            `mesh_keywords=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "IPC Classification No") {
          queryString +=
            `classification_no=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "CPC Classification No") {
          queryString +=
            `cpc_no=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "Application No") {
          queryString +=
            `application_no=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "Substances") {
          queryString +=
            `substances=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "Case Study Number") {
          queryString +=
            `casestudy_no=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "Publication Country") {
          queryString +=
            `primary_publisher_country=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "Author Country") {
          queryString +=
            `author_country_name=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        // @ts-ignore
        if (myFields[i].criteriaField === "Journal") {
          // @ts-ignore
          const journalArrays = fields[i]?.selectedJournal[0].split(", ");
          const result = journalArrays
            .map((journal: any) => `"${journal}"`)
            .join(" OR ");
          queryString +=
            `resource_name_tk=(${result.replace(/&/g, "and")})` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }

        if (myFields[i].criteriaField === "Author Affiliation") {
          queryString +=
            `author_address_fz=${
              (myFields[i]?.searchTerm.trim(" ").includes(" ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" or ") &&
                !myFields[i].searchTerm.toLocaleLowerCase().includes(" and ") &&
                !myFields[i].searchTerm
                  .toLocaleLowerCase()
                  .includes(" not ")) ||
              (myFields[i].searchTerm.trim(" ").includes("(") &&
                myFields[i].searchTerm.trim(" ").includes(")"))
                ? `(${myFields[i].searchTerm.replace(/^\(|\)$/g, "")})`
                : addParentheses(myFields[i].searchTerm)
            }` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "ISSN") {
          queryString +=
            `issn="${myFields[i].searchTerm?.trim().replace(/['"]/g, "")}"` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "ISBN") {
          queryString +=
            `isbn="${myFields[i].searchTerm?.trim().replace(/['"]/g, "")}"` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "DOI") {
          queryString +=
            `articledoi="${myFields[i].searchTerm
              ?.replace(/['"]/g, "")
              .toLowerCase()}"` +
            `${isLastField ? "" : " "}` +
            `${!isLastField ? myFields[i].conditionField : ""}` +
            `${isLastField ? "" : " "}`;
        }
        if (myFields[i].criteriaField === "Author") {
          queryString +=
            // `author_all_fz=("${myFields[i].author_firstname_fz}")${
            //   myFields[i].author_lastname
            //     ? `AND author_all_fz:("${myFields[i].author_lastname}") `
            //     : ""
            // }` +
            // myFields[i].author_lastname
            //   ? `(author_all_fz=${myFields[i].author_firstname_fz}` +
            //     " AND " +
            //     `author_all_fz=${myFields[i].author_lastname})`
            //   : `(author_all_fz=${myFields[i].author_firstname_fz})` +
            //     `${isLastField ? "" : " "}` +
            //     `${!isLastField ? myFields[i].conditionField : ""}` +
            //     `${isLastField ? "" : " "}`;

            myFields[i].author_lastname && myFields[i].author_firstname_fz
              ? // ? `(author_all_fz=${myFields[i].author_firstname_fz}` +
                //   " AND " +
                //   `author_all_fz=${myFields[i].author_lastname})`
                `author_all_fz=("${myFields[i].author_lastname}, ${myFields[i].author_firstname_fz}")`
              : myFields[i].author_lastname
                ? `(author_all_fz=${myFields[i].author_lastname})` +
                  `${isLastField ? "" : " "}` +
                  `${!isLastField ? myFields[i].conditionField : ""}` +
                  `${isLastField ? "" : " "}`
                : `(author_all_fz=${myFields[i].author_firstname_fz})` +
                  `${isLastField ? "" : " "}` +
                  `${!isLastField ? myFields[i].conditionField : ""}` +
                  `${isLastField ? "" : " "}`;
        }
      }
      // -----------------------------------For Loop ends -----------------------------------------//
      // TO ADD THE () IN THE SEARCH IF THE USER EDITS THE SEARCH IN QUERY BUILDER
      let x = queryString.split("=");
      let b = displayQuery.split(" : ");
      let a: any = [];
      function removeTermsNotPresentInBoth(
        string1: string,
        string2: string,
      ): [string, string, any] {
        // Extract terms from both strings
        var terms1 = (string1.match(/\b\w+\b/g) || []) as any;
        var terms2 = (string2.match(/\b\w+\b/g) || []) as any;

        // Identify terms present in only one of the strings
        var termsToRemove = terms1
          .filter((term: any) => !terms2.includes(term))
          .concat(terms2.filter((term: any) => !terms1.includes(term)));

        // Remove identified terms from both strings
        termsToRemove.forEach((term: any) => {
          string1 = string1.replace(
            new RegExp(`\\b${term}\\b\\s*(?:AND|OR|NOT)?\\s*`, "i"),
            "",
          );
          string2 = string2.replace(
            new RegExp(`\\b${term}\\b\\s*(?:AND|OR|NOT)?\\s*`, "i"),
            "",
          );
        });
        if (x.length == b.length || myFields.length == 1) {
          return [string1.trim(), string2.trim(), []];
        } else {
          return [string1.trim(), string2.trim(), termsToRemove];
        }
      }
      let [updatedString1, updatedString2, removedStr] =
        removeTermsNotPresentInBoth(
          x[x.length - 1].includes("keywords_fz")
            ? b[b.length - 1]
            : x[x.length - 1],
          myFields.length - 1 > 0 ? b[b.length - 1] : x[x.length - 1],
        );
      let extraStr = removedStr.map((item: string) => {
        if (
          item == "and" ||
          item == "or" ||
          item == "not" ||
          item == "AND" ||
          item == "OR" ||
          item == "NOT" ||
          item == "TO"
        ) {
          if (item == "TO") {
            return;
          }
          return item;
        } else {
          return item.trim().includes(" ")
            ? `titleKeywordsAbs=(${item})`
            : `titleKeywordsAbs=${item}`;
        }
      });
      function q(qS: string, dS: string) {
        setExtraStringQuery(extraStr.join(" "));
        let modifiedQueryString = dS
          .replace(removedStr.join(" "), "")
          .split(/\s{2}/);
        let c: any = [];
        modifiedQueryString.map((item: any, index: any) => {
          if (
            item.trim().includes("TI/KW/Abst :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            }
            // else if (modifiedQueryString[index + 1].trim().includes("(") &&
            //   modifiedQueryString[index + 1].trim().includes(")")) {
            //   modifiedST = `${modifiedQueryString[index + 1].replace(
            //     /^\(|\)$/g,
            //     ""
            //   )}`;
            // }
            // else if (
            //   modifiedQueryString[index + 1].trim().includes(" ") ||
            //   (modifiedQueryString[index + 1].trim().includes("(") ||
            //     modifiedQueryString[index + 1].trim().includes(")"))
            // ) {
            //   modifiedST = `(${modifiedQueryString[index + 1]})`;
            // }
            else {
              modifiedST = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "TI/KW/Abst :",
              `titleKeywordsAbs=${modifiedST.trim()} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("TIKW :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let keyWordSearchTerm;
            let titleKeywordSearchTerm;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              keyWordSearchTerm = addParentheses(
                modifiedQueryString[index + 1],
              );
            } else {
              keyWordSearchTerm = modifiedQueryString[index + 1];
            }
            // TITLE KEYWORD
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              titleKeywordSearchTerm = addParentheses(
                modifiedQueryString[index + 1],
              );
            } else {
              titleKeywordSearchTerm = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "TIKW :",
              `(title_fz=${titleKeywordSearchTerm.trim()} OR keywords_fz=${keyWordSearchTerm.trim()}) ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("MeSH :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "MeSH :",
              `mesh_keywords=${modifiedST.trim()} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("Appl. No :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            const trimmedST = modifiedST.trim();
            const isQuoted =
              (trimmedST.startsWith('"') && trimmedST.endsWith('"')) ||
              (trimmedST.startsWith("'") && trimmedST.endsWith("'"));

            const finalValue = isQuoted ? trimmedST : `"${trimmedST}"`;
            let z = item.replace(
              "Appl. No :",
              `application_no=${finalValue} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("IPC Classif. No :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }

            const trimmedST = modifiedST.trim();
            const isQuoted =
              (trimmedST.startsWith('"') && trimmedST.endsWith('"')) ||
              (trimmedST.startsWith("'") && trimmedST.endsWith("'"));

            const finalValue = isQuoted ? trimmedST : `"${trimmedST}"`;
            let z = item.replace(
              "IPC Classif. No :",
              `classification_no=${finalValue} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);

            // let z = item.replace(
            //   "Classif. No :",
            //   `classification_no=${modifiedST.trim()} ${
            //     modifiedQueryString[index + 2] !== undefined
            //       ? modifiedQueryString[index + 2]
            //       : ""
            //   }`,
            // );
            // c.push(z);
          } else if (
            item.trim().includes("CPC Classif. No :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }

            const trimmedST = modifiedST.trim();
            const isQuoted =
              (trimmedST.startsWith('"') && trimmedST.endsWith('"')) ||
              (trimmedST.startsWith("'") && trimmedST.endsWith("'"));

            const finalValue = isQuoted ? trimmedST : `"${trimmedST}"`;
            let z = item.replace(
              "CPC Classif. No :",
              `cpc_no=${finalValue} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);

            // let z = item.replace(
            //   "Classif. No :",
            //   `classification_no=${modifiedST.trim()} ${
            //     modifiedQueryString[index + 2] !== undefined
            //       ? modifiedQueryString[index + 2]
            //       : ""
            //   }`,
            // );
            // c.push(z);
          } else if (
            item.trim().includes("Substances :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "Substances :",
              `substances=${modifiedST.trim()} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("Case Study Number :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            const trimmedST = modifiedST.trim();
            const isQuoted =
              (trimmedST.startsWith('"') && trimmedST.endsWith('"')) ||
              (trimmedST.startsWith("'") && trimmedST.endsWith("'"));

            const finalValue = isQuoted ? trimmedST : `"${trimmedST}"`;
            let z = item.replace(
              "Case Study Number :",
              `casestudy_no=${finalValue} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("AC :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            const trimmedST = modifiedST.trim();

            //Convert to Title Case function
            function toTitleCase(str: string) {
              return str
                .toLowerCase()
                .split(" ")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
            }

            // Remove surrounding quotes if present
            const unquoted = trimmedST.replace(/^['"]|['"]$/g, "");

            // Apply Title Case
            const titleCased = toTitleCase(unquoted);

            // Always wrap back in quotes
            const finalValue = `"${titleCased}"`;

            // //Apply Title Case
            // const titleCased = toTitleCase(trimmedST);

            // const isQuoted =
            //   (titleCased.startsWith('"') && titleCased.endsWith('"')) ||
            //   (titleCased.startsWith("'") && titleCased.endsWith("'"));

            // const finalValue = isQuoted ? titleCased : `"${titleCased}"`;
            let z = item.replace(
              "AC :",
              `author_country_name=${finalValue} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("PC :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "PC :",
              `primary_publisher_country=${modifiedST.trim()} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("KW :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "KW :",
              `keywords_fz=${modifiedST.trim()} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("TI :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" and ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" or ") ||
              modifiedQueryString[index + 1]
                .toLocaleLowerCase()
                .includes(" not ")
            ) {
              modifiedST = addParentheses(modifiedQueryString[index + 1]);
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "TI :",
              `title_fz=${modifiedST.trim()} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("Date :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let dates = modifiedQueryString[index + 1].replace(" - ", " TO ");
            let z = item.replace(
              "Date :",
              `yearfrom=[${dates.trim()}] ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("AU :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let z = item.replace(
              "AU :",
              `author_all_fz=("${modifiedQueryString[index + 1].trim()}") ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("AF :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let modifiedST;
            if (
              modifiedQueryString[index + 1].trim().includes(" ") ||
              (modifiedQueryString[index + 1].trim().includes("(") &&
                modifiedQueryString[index + 1].trim().includes(")"))
            ) {
              modifiedST = `(${modifiedQueryString[index + 1].replace(
                /^\(|\)$/g,
                "",
              )})`;
            } else {
              modifiedST = modifiedQueryString[index + 1];
            }
            let z = item.replace(
              "AF :",
              `author_address_fz=${modifiedST.trim()} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("ISSN :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let z = item.replace(
              "ISSN :",
              `issn=${modifiedQueryString[index + 1]
                .trim()
                .replace(/['"]/g, "")} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2].trim()
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("ISBN :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let z = item.replace(
              "ISBN :",
              `isbn=${modifiedQueryString[index + 1]
                .trim()
                .replace(/['"-]/g, "")} ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2].trim()
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("DOI :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let z = item.replace(
              "DOI :",
              `articledoi="${modifiedQueryString[index + 1]
                .replace(/['"]/g, "")
                .trim()
                .toLowerCase()}" ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          } else if (
            item.trim().includes("JRNL :") &&
            modifiedQueryString[index + 1] != " "
          ) {
            let jr = modifiedQueryString[index + 1]
              .split(", ")
              .map((journalListing) => `"${journalListing.trim()}"`);
            let z = item.replace(
              "JRNL :",
              `resource_name_tk=(${jr.join(" OR ").trim()}) ${
                modifiedQueryString[index + 2] !== undefined
                  ? modifiedQueryString[index + 2]
                  : ""
              }`,
            );
            c.push(z);
          }
        });
        return c.join(" ");
      }

      let modQuery = q(queryString, displayQuery);
      return modQuery + extraStr.join(" ");
    } catch (err) {
      console.log(err);
      return "";
    }
  };
  function formAdvanceQueryX(): string {
    let finalQuery = ""; // Final output exact query that need to send to the api
    const userInput = displayQuery;
    let qArray = [];
    const queryKeys = [
      "TI/KW/Abst",
      "TI",
      "KW",
      "TIKW",
      "Date",
      "AU",
      "AF",
      "ISSN",
      "ISBN",
      "DOI",
      "JRNL",
    ];
    const commonOperator = ["AND", "OR", "NOT"];

    function isOperator(value: string) {
      if (!value) return false;
      if (commonOperator.includes(value.toLocaleUpperCase())) {
        return true;
      } else {
        return false;
      }
    }

    // Split the userinput string to form url query
    const splitedArray = customSplit2(userInput);

    if (!Array.isArray(splitedArray)) return ""; // Return if is not an array;

    // Loop through the splitedArray
    for (let i = 0; i < splitedArray.length; i++) {
      let flag = false;

      if (splitedArray[i]?.startsWith("(") && splitedArray[i]?.endsWith(")")) {
        let arr = customSplit(splitedArray[i]?.slice(1, -1));

        // Check any query keys availabel in the arr
        let found = false;
        for (let obj of arr) {
          if (queryKeys.includes(obj)) {
            found = true;
            break;
          }
        }
        if (found) {
          let qArr = FormAdvanceQueryTerm(arr);
          let str = `(${qArr.join(" ")})`;
          if (isOperator(splitedArray[i + 1])) {
            str += ` ${splitedArray[i + 1]}`;
          }
          qArray.push(str);
          flag = true;
        }
      }

      if (splitedArray[i] === "TI/KW/Abst") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim();
        let operator = splitedArray[i + 1];
        let term = `titleKeywordsAbs=${searchTerm}${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "TIKW") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim();
        let operator = splitedArray[i + 1];
        let term = `(title_fz=${searchTerm} OR keywords_fz=${searchTerm})${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "KW") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim();
        let operator = splitedArray[i + 1];
        let term = `keywords_fz=${searchTerm}${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "TI") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim();
        let operator = splitedArray[i + 1];
        let term = `title_fz=${searchTerm}${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "Date") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim()?.replace(/[()]/g, "");
        let operator = splitedArray[i + 1];
        let dates = searchTerm.replace(" - ", " TO ");
        const term = `yearfrom=[${dates.trim()}]${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "AU") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim();
        let operator = splitedArray[i + 1];
        const term = `author_all_fz=("${searchTerm}")${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "AF") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim();
        let operator = splitedArray[i + 1];
        let term = `author_address_fz=${searchTerm}${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "ISSN") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim()?.replace(/['"]/g, "");
        let operator = splitedArray[i + 1];
        let term = `issn=${searchTerm}${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "ISBN") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim()?.replace(/['"]/g, "");
        let operator = splitedArray[i + 1];
        let term = `isbn=${searchTerm}${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "DOI") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim()?.replace(/['"]/g, "");
        let operator = splitedArray[i + 1];
        let term = `articledoi="${searchTerm.toLowerCase()}"${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      } else if (splitedArray[i] === "JRNL") {
        flag = true;
        let searchTerm = splitedArray[i - 1]?.trim();
        let operator = splitedArray[i + 1];

        let value = searchTerm
          .split(", ")
          .map((journalListing) => `"${journalListing.trim()}"`);
        const term = `resource_name_tk=(${value.join(" OR ").trim()})${
          isOperator(operator) ? ` ${operator}` : ""
        }`;
        qArray.push(term);
      }

      // handling the extra search term added by user
      if (
        !queryKeys.includes(splitedArray[i]) &&
        !isOperator(splitedArray[i]) &&
        !queryKeys.includes(splitedArray[i + 1]) &&
        !flag
      ) {
        let term = `titleKeywordsAbs=${splitedArray[i]}${
          isOperator(splitedArray[i + 1]) ? ` ${splitedArray[i + 1]}` : ""
        }`;
        qArray.push(term);
      }
    }
    finalQuery = qArray.join(" ");
    finalQuery = replaceBrackets(finalQuery);
    return finalQuery;
  }

  function replaceBrackets(str: string) {
    // Replace [ with (
    let replacedStr = str.replace(/\[/g, "(");

    // Replace ] with )
    replacedStr = replacedStr.replace(/\]/g, ")");

    return replacedStr;
  }

  function customSplit(str: string): any[] {
    // Split the string using a regular expression if string is enclose by [] it will be taken as one string
    let x = str.match(/\[[^\]]*\]|[^[\]\s]+/g);
    if (x) {
      return x;
    } else {
      return str.split(" ");
    }
  }

  function customSplit2(str: string) {
    // Split the string by " ". if it enclosed by [] or () will take it as one word
    return str.match(/\[[^\]]*\]|\([^\)]*\)|[^[\]\(\)\s]+/g);
  }

  function isSpecialCharacters(input: any) {
    // Define a regular expression pattern that matches any character that is not a letter or digit
    const regex = /^[^a-zA-Z0-9]+$/;

    // Use the test() method to check if the input matches the pattern
    return regex.test(input);
  }

  const formSearchTerm = (myFields: any): string => {
    try {
      const queryKeys = [
        "TI/KW/Abst :",
        "TI :",
        "MeSH :",
        "KW :",
        "TIKW :",
        "Date :",
        "AU :",
        "AF :",
        "ISSN :",
        "ISBN :",
        "DOI :",
        "JRNL :",
        "PC :",
        "Appl No :",
        // "Classif. No :",
        "IPC Classif. No :",
        "CPC Classif. No :",
        "Substances :",
        "AC :",
      ];

      let query = displayQuery;
      for (let obj of queryKeys) {
        query = query?.replaceAll(obj, "");
      }

      query = replaceBrackets(query);
      // -----------------------------------For Loop ends -----------------------------------------//
      return query;
    } catch (err) {
      console.log(err);
      return "";
    }
  };

  async function checkPreferenceAdded(myPreference: GetMyPreferenceData) {
    if (!myPreference) return;

    const filteredSelectedTags = myPreference?.DataTypes.filter(
      ({ is_favorite }: any) => is_favorite,
    ).map(({ datatype_id }) => datatype_id);
    if (filteredSelectedTags?.filter((ele: any) => ele !== 2)?.length === 0) {
      setIsPreference(false);
      sessionStorage.setItem("preference", "false");
    }
  }

  const handlePreference = (event: React.ChangeEvent<HTMLInputElement>) => {
    logBasicSearchUsageData(112);
    if (sessionStorage.getItem("isProfileUser") === "true") {
      let isMyPrefAdded: boolean = true;
      if (myPreference) {
        isMyPrefAdded = isPreferenceAdded(myPreference);
      }
      if (!isMyPrefAdded && event.target.checked) {
        dispatch(
          setModal({
            modalType: "PREFERENCE",
            modalProps: {
              open: true,
              checkPreferenceAdded,
            },
          }),
        );
      }
      if (!event.target.checked) {
        dispatch(clearDataTypeFilters());
        // On dissabling the preference select all doc types
        let allDocIds: any = customerData?.datatypes
          .filter((x) => x.dat_resourcetype_id !== 2)
          ?.map((obj) => obj?.dat_resourcetype_id);
        setSelectedTags(() => [...allDocIds, 0]);
      }
      setIsPreference(event.target.checked);
      sessionStorage.setItem("preference", event.target.checked.toString());
    } else {
      showIsProfileToast("Please login as profile user to use the preferences");
    }
  };

  const setJournalResult = useCallback(async () => {
    let resourceList = "";
    let subjects = "";
    let dataTypes = "";
    if (customerData?.subject?.length) {
      customerData?.subject?.map((element: any, index: any) => {
        subjects += `${element.datsubjectmasterlevel2_id} OR `;
      });
      subjects = `(${subjects.slice(0, -3)})`;
    }

    if (customerData?.datatypes?.length) {
      customerData?.datatypes?.map((element: any, index: any) => {
        dataTypes += `${element.dat_resourcetype_id} OR `;
      });
      dataTypes = `(${dataTypes.slice(0, -3)})`;
    }

    //  @ts-ignore
    if (fields[indexOf]?.contain) {
      let key = "";
      autoSearchKeyword
        ?.split(" ")
        ?.map((ele: any) => (key += ele?.replace(/^"+|"+|"+|"$/g, "") + "\\ "));
      resourceList +=
        key?.indexOf(":\\") > -1
          ? `(resource_name_fz="${key
              .split(":\\")
              .join("/:\\")}*" OR resource_shortname_fz="${key
              .split(":\\")
              .join("/:\\")}*") AND `
          : `(resource_name_tk=${key}* OR resource_shortname_tk=${key}*)`;
    }
    // @ts-ignore
    else if (fields[indexOf]?.start) {
      let key = "";
      autoSearchKeyword
        ?.split(" ")
        ?.map((ele: any) => (key += ele?.replace(/^"+|"+|"+|"$/g, "") + "\\ "));
      resourceList +=
        key?.indexOf(":") > -1
          ? `(resource_name_fz=("*${key
              ?.substring(key?.indexOf(":") + 2)
              ?.split(" ")
              .join("\\ ")}"*)+OR+resource_shortname_fz:("*${key
              ?.substring(key?.indexOf(":") + 2)
              ?.split(" ")
              .join("\\ ")}"*)) AND`
          : `(resource_name_fz=(${key}) +OR+resource_shortname_fz:(${key})) AND `;
    }

    resourceList = `&${resourceList.slice(0, -6)})`;
    let apiJournalData: any = {
      // @ts-ignore
      page: fields[indexOf]?.pageIndex || 1,
      rows: 15,
      profileuserid: userId,
      sessionid: session_key,
      facet_fields:
        "publisher_name,primary_publisher_country,subjects_name_l3,resource_source_index,filter_metrix,resource_name_initial",

      fq__active_flag: true,
      sort: "resource_name_tk asc",
      // json_facet:JSON.stringify({"resource_name_tk":{"type":"terms","field":"resource_name_tk","limit":15,"sort":"index asc"}}),
      fl: "resource_name",
      op_mode: "and",
    };
    if (selectedTagPublisher !== "" && selectedTagPublisher !== "0-9") {
      Object.assign(apiJournalData, {
        fq__resource_name_initial: selectedTagPublisher,
      });
    }
    if (dataTypes.length > 2)
      Object.assign(apiJournalData, { fq__resource_type: dataTypes });
    Object.assign(apiJournalData, { fq__subjects_id_l2: subjects });
    let response;
    if (autoSearchKeyword.length > 0) {
      response = await getListOfJournal(
        "resourcecore?" + objectToQueryString(apiJournalData) + resourceList,
      );
    } else {
      response = await getListOfJournal(
        "resourcecore?" + objectToQueryString(apiJournalData),
      );
    }
    setJournalData(response?.data.data.docs);
  }, [
    autoSearchKeyword,
    fields,
    indexOf,
    selectedTagPublisher,
    session_key,
    userId,
  ]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      setJournalResult();
    }, 100);

    return () => {
      clearTimeout(debounce);
    };
  }, [selectedTagPublisher, pageIndex, setJournalResult]);

  const onPaginate = (val: any) => {
    // @ts-ignore
    if (val == "-1" && fields[indexOf].pageIndex !== 0) {
      // @ts-ignore
      fields[indexOf].pageIndex = fields[indexOf].pageIndex - 1;
    } else {
      // @ts-ignore
      fields[indexOf].pageIndex = fields[indexOf].pageIndex + 1;
    }
    // @ts-ignore
    setpageIndex(fields[indexOf].pageIndex);
  };

  async function linkToDisplay(dataArray: any) {
    if (!Array.isArray(dataArray)) return;
    let formData = new FormData();

    let data = dataArray?.map((obj: any) => {
      let object: any = {
        customer_id: customerData?.informaticscustomer_id,
        article_id: obj?.article_id,
        consortia_virtualid: customerData?.consortia_virtualid,
        resource_type: obj?.resource_type,
        access_type: obj?.article_open_status || obj?.access_type_id || null,
        is_oa_article: obj?.fulltext || false,
      };

      if (obj?.articledoi) {
        object.article_doi = obj?.articledoi;
      }

      if (obj?.resourceissue_id) {
        object.resourceissue_id = obj?.resourceissue_id;
      }

      if (obj?.is_onos_resource) {
        object.is_onos_resource = true;
      }

      return object;
    });

    let formApiData = {
      data,
    };

    formData.append("detailed_json", JSON.stringify(formApiData));
    const response = await getBulkLinkRecords(formData);

    if (response?.message === "Ok") {
      dispatch(updateLinkToDisplay(response?.data));
    }
  }

  useEffect(() => {
    selectAllTags();
  }, [selectedTags.length]);

  useEffect(() => {
    if (
      profileData1?.product_type === "1" ||
      profileData1?.product_type === "1,7"
    ) {
      dispatch(updateCollectionValue("J-GateCollection"));
      dispatch(updateMyLibraryCollection(false));
      dispatch(updateConsortiaCollection(false));
      dispatch(updateOnosCollection(false));
      dispatch(updatePersonalLibrary(false));
      dispatch(updataLibraryOpac(false));
      dispatch(updateJgateCollection(true));
    } else if (profileData1?.product_type === "7") {
      dispatch(updateCollectionValue("ConsortiaSubscriptions"));
      dispatch(updateMyLibraryCollection(false));
      dispatch(updateJgateCollection(false));
      dispatch(updateConsortiaCollection(true));
      dispatch(updateOnosCollection(false));
      dispatch(updatePersonalLibrary(false));
      dispatch(updataLibraryOpac(false));
    }
  }, []);
  function selectAllTags() {
    // No-op: ALL mode is only triggered by explicitly clicking the ALL chip.
  }

  function openTutorialLink() {
    //window.open("https://youtu.be/H2oyJDz4Bew", "_blank");
    window.open("https://youtu.be/eBJvYSs_Gao", "_blank");
  }

  function openPreferenceInfoModal() {
    dispatch(
      setModal({
        modalType: "PREFERENCE_INFO_MODEL",
        modalProps: {
          isOpen: true,
          from: "basicsearch",
        },
      }),
    );
  }
  const handleRemove = (tagsArray: any[]) => {
    setSelectedTags([]);
  };

  return (
    <Box className="search-builder-container">
      {/* <FormProvider {...methods}> */}

      <HeaderSection isAdvanceSearch />

      <Stack
        direction={{ xs: "column", sm: "column", md: "row" }}
        spacing={{ xs: 1, sm: 1, md: 10, lg: 10, xl: 10 }}
        alignItems={{
          xs: "start",
          sm: "start",
          md: "center",
          lg: "center",
          xl: "center",
        }}
        paddingTop={{ xs: "0rem", sm: "2rem" }}
        sx={{ pl: { xs: "10px", sm: "40px", md: "66px" } }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: {
              xs: "start",
              sm: "start",
              md: "space-between",
              lg: "space-between",
              xl: "space-between",
            },
          }}
        >
          <Text
            variant="h5"
            fontWeight={"600"}
            fontSize={{ xs: "1rem", sm: "1.5rem" }}
          >
            Search Builder
          </Text>
          <Stack
            direction={"row"}
            //spacing={{ xs: 1, sm: 2, md: 1 }}
            spacing={1}
            alignItems="center"
            marginLeft={{ xs: "none", sm: "20px" }}
          >
            <FormControlLabel
              control={
                <Switch
                  sx={{ m: 1 }}
                  checked={isPreference}
                  onChange={handlePreference}
                  inputProps={{ "aria-label": "Preferences Switch" }}
                />
              }
              label="Preferences"
              labelPlacement="start"
            />
            <Stack>
              <IconButton size="medium" onClick={openPreferenceInfoModal}>
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Stack>
          </Stack>
        </Stack>
        <Stack>
          <Link
            style={{
              cursor: "pointer",
              color: "#e35c19",
              textDecorationColor: "#e35c19",
            }}
            onClick={openTutorialLink}
          >
            Take a Quick Tour of Search Builder
          </Link>
        </Stack>
      </Stack>

      {/* Tags */}
      <Stack
        direction={"row"}
        spacing={1.2}
        marginTop={1}
        flexWrap="wrap"
        sx={{
          pl: { xs: "10px", sm: "40px", md: "66px" },
          marginTop: { xs: "20px", sm: "20px" },
        }}
      >
        {sortTags(allTags)
          ?.slice(0, activeScreenWidth)
          ?.map((data) => (
            <Chip
              key={data.dat_resourcetype_id}
              label={
                data.accesstype === dataTypes.journals
                  ? "Journal Articles"
                  : data?.accesstype
              }
              color="primary"
              variant={"outlined"}
              onClick={() => handleTags(data.dat_resourcetype_id)}
              sx={{
                p: "4px",
                borderRadius: "6px",
                border: "1px solid",
                borderColor: (
                  data.dat_resourcetype_id === 0
                    ? selectedTags.includes(0)
                    : selectedTags.includes(data.dat_resourcetype_id) &&
                      !selectedTags.includes(0)
                )
                  ? "primary.main"
                  : "#DCD2EF",
                background: (
                  data.dat_resourcetype_id === 0
                    ? selectedTags.includes(0)
                    : selectedTags.includes(data.dat_resourcetype_id) &&
                      !selectedTags.includes(0)
                )
                  ? "#DCD2EF"
                  : "#FFF",
                color: (
                  data.dat_resourcetype_id === 0
                    ? selectedTags.includes(0)
                    : selectedTags.includes(data.dat_resourcetype_id) &&
                      !selectedTags.includes(0)
                )
                  ? "primary.main"
                  : "#71717A",
                textTransform: "capitalize",
                "&:hover": {
                  background: "#DCD2EF",
                },
              }}
            />
          ))}

        {allTags?.slice(activeScreenWidth).length > 0 && (
          <Select
            displayEmpty
            renderValue={() =>
              isxs || is_xs ? "Select document types" : "Other document types"
            }
            open={dropdown}
            onClose={() => setDropDown(false)}
            onOpen={() => {
              setDropDown(true);
            }}
            sx={{
              border: "1px solid",
              borderColor:
                !selectedTags.includes(0) &&
                selectedTags?.some((tag) =>
                  allTags
                    ?.slice(activeScreenWidth)
                    ?.map((item) => {
                      return item?.dat_resourcetype_id;
                    })
                    ?.includes(tag),
                )
                  ? "primary.main"
                  : "#DCD2EF",
              borderRadius: "6px",
              background:
                !selectedTags.includes(0) &&
                selectedTags?.some((tag) =>
                  allTags
                    ?.slice(activeScreenWidth)
                    ?.map((item) => {
                      return item?.dat_resourcetype_id;
                    })
                    ?.includes(tag),
                )
                  ? "#DCD2EF"
                  : "#FFF",
              color:
                !selectedTags.includes(0) &&
                selectedTags?.some((tag) =>
                  allTags
                    ?.slice(activeScreenWidth)
                    ?.map((item) => {
                      return item?.dat_resourcetype_id;
                    })
                    ?.includes(tag),
                )
                  ? "primary.main"
                  : "#71717A",

              "& .MuiSelect-select": {
                padding: "1px 1px 1px 12px",
                display: "flex",
                alignItems: "center",
                textTransform: "capitalize",
                border: "none",
                fontSize: "12px",
              },
            }}
          >
            <Box>
              <Box
                sx={{
                  padding: "12px 24px 24px 12px",
                  display: "grid",
                  //gridTemplateColumns: "repeat(4, 1fr)",
                  // gridTemplateColumns: "repeat(1fr)",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "1fr 1fr",
                    md: "1fr 1fr 1fr",
                    lg: "1fr 1fr",
                  },
                  gap: "1px",
                }}
              >
                {allTags?.slice(activeScreenWidth)?.map((data) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyItems: "center",
                    }}
                  >
                    <Checkbox
                      checked={
                        selectedTags.includes(data.dat_resourcetype_id) &&
                        !selectedTags.includes(0)
                      }
                      onClick={() => handleTags(data.dat_resourcetype_id)}
                    />
                    <Typography sx={{ fontSize: "13px", fontWeight: "400" }}>
                      {data.accesstype === dataTypes.journals
                        ? dataTypes.journalArticle
                        : data?.accesstype}
                    </Typography>
                  </Box>
                ))}
              </Box>
              <Box
                sx={{ display: "flex", gap: 3, padding: "0px 12px 10px  12px" }}
              >
                <Button variant="contained" onClick={() => setDropDown(false)}>
                  Apply
                </Button>
                <Button
                  variant="text"
                  onClick={() => {
                    handleRemove(allTags?.slice(4));
                    setDropDown(false);
                  }}
                >
                  Clear All
                </Button>
              </Box>
            </Box>
          </Select>
        )}
      </Stack>

      {/* Query Builder */}
      {fields?.map((data, i) => (
        <QueryBuilder
          key={data.id}
          setJournalResult={setJournalResult}
          setJournal={setJournal}
          index={i}
          append={append}
          remove={remove}
          qbField={fields}
          control={control}
          fields={fields}
          setIndexOf={setIndexOf}
          pageIndex={pageIndex}
          handleSubmit={handleSubmit(handleFormSubmit)}
          selectedTags={selectedTags}
          setCheckDoi={setCheckDoi}
          checkDoi={checkDoi}
          getValues={getValues}
        />
      ))}

      {/* Query Editor */}
      <Box my={4} sx={{ pl: { xs: "10px", sm: "40px", md: "66px" } }}>
        <Text variant="h5" fontWeight={"600"}>
          Query Editor
        </Text>
        <Box sx={sx.queryEditor}>
          <Box
            sx={{
              width: { xs: "100%", sm: "80%", md: "600px", lg: "1000px" },
            }}
          >
            <Text fontWeight={"500"}>Query</Text>
            <TextField
              fullWidth
              value={displayQuery}
              onChange={(e) => setDisplayQuery(`${e.target.value}`)}
              sx={{
                width: "100%",
                fontWeight: 600,
                backgroundColor: "#FFF",
              }}
            />
          </Box>
          <Button
            variant="contained"
            onClick={handleSubmit(handleFormSubmit)}
            sx={{ height: "51px", width: "130px", marginY: "1.5rem" }}
            disabled={!selectedTags.length || !displayQuery}
          >
            {loading ? (
              <CircularProgress
                size={24}
                sx={{
                  color: "#fff",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            ) : (
              "Search"
            )}
          </Button>
        </Box>
      </Box>

      {/* Journal Modal */}
      {fields?.map((_: any, i: number) => (
        <JournalPopUp
          key={i}
          setValue={setValue}
          journalData={journalData}
          handleCloseJournalData={handleCloseJournalData}
          onJournal={onJournal}
          selectedLetterTagsPublisher={selectedLetterTagsPublisher}
          updateSelectedTagsPublisher={updateSelectedTagsPublisher}
          onChange={onChange}
          indexOf={indexOf}
          setSelectedJournal={setSelectedJournal}
          selectedJournal={selectedJournal}
          fields={fields}
          setJournal={setJournal}
          setAutoSearchKeyword={setAutoSearchKeyword}
          setAutoSearch={setAutoSearch}
          autoSearch={autoSearch}
          setJournalResult={setJournalResult}
          onPaginate={onPaginate}
          setOnChange={setOnChange}
        />
      ))}
      {/* </FormProvider>  */}
    </Box>
  );
};

export default AdvancedSearch;
